import { BigFormRow, FormRow, FormSection } from 'framework/ui/layout';
import { EmployeePhotoUploaderInput } from 'domain/shared/employee';
import EmployeeWorkingStatusDropdown from 'domain/people/employee/shared/input/EmployeeWorkingStatusDropdown';
import MentorMenteesSelectionSection from 'domain/people/employee/shared/input/MentorMenteesSelectionSection';
import { FC } from 'react';
import { DateInput, GenderRadioButtonGroup, NameInput, TextInput } from 'framework/form';

type MainInfoUpdateSectionProps = {
  isGrantedUpdateMainInfo: boolean;
  isGrantedReadStatus: boolean;
};

const MainInfoUpdateSection: FC<MainInfoUpdateSectionProps> = ({ isGrantedUpdateMainInfo, isGrantedReadStatus }) => {
  return (
    <FormSection title="Main information" isVisible={isGrantedUpdateMainInfo || isGrantedReadStatus}>
      <NameInput
        label="Local name"
        source="nameLocal"
        middleNameLabel="Patronymic name"
        isVisible={isGrantedUpdateMainInfo}
      />
      <NameInput label="Latin name" source="nameEn" middleNameLabel="Middle name" isVisible={isGrantedUpdateMainInfo} />
      <FormRow>
        <DateInput source="extendedInformation.dateOfBirth" label="Date of birth" isVisible={isGrantedUpdateMainInfo} />
        <TextInput label="Syberry email" source="workingEmail" isVisible={isGrantedUpdateMainInfo} />
        <EmployeeWorkingStatusDropdown
          isVisible={isGrantedReadStatus}
          disabled
          source="workingStatus"
          helpText="This field can be updated only within DaVinci processes"
        />
      </FormRow>
      <MentorMenteesSelectionSection />
      <BigFormRow>
        <GenderRadioButtonGroup source="gender" label="Gender" isVisible={isGrantedUpdateMainInfo} />
      </BigFormRow>
      <BigFormRow>
        <EmployeePhotoUploaderInput
          label="Worker photos"
          source="extendedInformation.photosIds"
          isVisible={isGrantedUpdateMainInfo}
        />
      </BigFormRow>
    </FormSection>
  );
};

export { MainInfoUpdateSection };
